/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { setTimeZone } from "@microsoft/shifts-experiences-shared";
import setTeamSettingInStore from "../mutatorActions/setTeamSettingInStore";
import setTeamSettings from "../actions/setTeamSettings";
import teamSettingsChanged from "../actions/teamSettingsChanged";
import timeZoneChanged from "../actions/timeZoneChanged";
import { orchestrator } from "satcheljs";
import { TeamSettingEntity, TeamSettingsKeys } from "sh-models";
import { TeamSettingsStore } from "..";

export default orchestrator(setTeamSettings, async actionMessage => {
    const teamSettings = actionMessage.teamSettings;

    if (teamSettings && teamSettings.length) {
        for (const teamSetting of teamSettings) {

            if (teamSetting.key == TeamSettingsKeys.TimeZoneOlsonCode) {
                setTimeZone(TeamSettingEntity.getValueOrDefault(teamSetting));
            }

            const isTimeZoneSettingUninitialized = !TeamSettingsStore().timeZoneOlsonCode;
            // check if the timezone value is initialized and it is different from what's in store
            const hasTimeZoneSettingChanged = (!isTimeZoneSettingUninitialized) &&
            (teamSetting.key === TeamSettingsKeys.TimeZoneOlsonCode &&
                (TeamSettingsStore().timeZoneOlsonCode.value !== teamSetting.value));

            setTeamSettingInStore(teamSetting);

            if (hasTimeZoneSettingChanged) {
                // Fire the timezone changed action (This is done only when time zone has changed and is already initialized)
                timeZoneChanged(teamSetting.value);
            }
        }

        // Alert the view that new settings are available!
        teamSettingsChanged();
    }
});